export default __webpack_public_path__ + "static/media/hero@3x.485ef212.png";